export default __webpack_public_path__ + "static/media/cartop-pm1.e695259b.jpg";